var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "table-settings" },
    [
      _c("div", {
        staticClass: "table-settings__icon",
        domProps: { innerHTML: _vm._s(_vm.IcSettings) },
        on: {
          click: function($event) {
            $event.stopPropagation()
            return _vm.iconClickHandler($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "q-popup-proxy",
        {
          attrs: { value: _vm.opened },
          model: {
            value: _vm.opened,
            callback: function($$v) {
              _vm.opened = $$v
            },
            expression: "opened"
          }
        },
        [
          _c("div", { staticClass: "table-settings__popup" }, [
            _c("div", { staticClass: "table-settings__title" }, [
              _vm._v("\n        Настройки\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "table-settings__menu-items" },
              _vm._l(_vm.menuItems, function(menuItem, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "table-settings__menu-item" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: menuItem.hidden,
                          expression: "menuItem.hidden"
                        }
                      ],
                      staticClass: "table-settings__checkbox",
                      attrs: { type: "checkbox" },
                      domProps: {
                        checked: Array.isArray(menuItem.hidden)
                          ? _vm._i(menuItem.hidden, null) > -1
                          : menuItem.hidden
                      },
                      on: {
                        input: function($event) {
                          return _vm.updateMenuItem(menuItem)
                        },
                        change: function($event) {
                          var $$a = menuItem.hidden,
                            $$el = $event.target,
                            $$c = $$el.checked ? true : false
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                _vm.$set(menuItem, "hidden", $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                _vm.$set(
                                  menuItem,
                                  "hidden",
                                  $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                )
                            }
                          } else {
                            _vm.$set(menuItem, "hidden", $$c)
                          }
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "table-settings__label",
                        on: {
                          click: function($event) {
                            return _vm.updateMenuItem(menuItem)
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(menuItem.label) +
                            "\n          "
                        )
                      ]
                    )
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "table-settings__settings-reset",
                on: {
                  click: function($event) {
                    return _vm.$emit("reset-settings")
                  }
                }
              },
              [_vm._v("\n        Сбросить настройки\n      ")]
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }